import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const LazyLoadImage = ({ src, alt, className, srcSet, ...rest }) => {
  const supportsLoading = navigator.userAgent !== 'ReactSnap' && 'loading' in HTMLImageElement.prototype;
  return (
    <img
      loading="lazy"
      className={classnames({ lazyload: !supportsLoading }, className)}
      src={supportsLoading ? src : null}
      data-src={!supportsLoading ? src : null}
      srcSet={supportsLoading ? srcSet : null}
      data-srcset={!supportsLoading ? srcSet : null}
      alt={alt}
      {...rest}
    />
  );
};

LazyLoadImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  srcSet: PropTypes.string,
};

LazyLoadImage.defaultProps = {
  className: null,
  srcSet: null,
};

export { LazyLoadImage };
